/* global Homie */
import axios from 'axios';
import LoaderPopup from '../../shared/libs/LoaderPopup';

export default {
    template: '#auth-phone',
    data() {
        return {
            country_code: 52,
            phone_number: Homie.user.mobile_phone,
            show_contry_codes: false,
            code: '',
            code_send: false,
            code_verified: false,
            error: false,
            message: false
        }
    },
    methods: {
        showCountryCodes() {
            this.show_contry_codes = true;
        },
        hideCountryCodes() {
            this.show_contry_codes = false;
        },
        sendConfirmationCode() {
            this.error = false;
            let data = {
                grant_type: 'phone',
                value: `+${this.country_code}${this.phone_number}`
            };
            axios.post('/verifications', data)
            .then(response => {
                this.code_send = true;
                this.message = response.data.message;
            })
            .catch(error => {
                this.error = error.response.data.message;
            });
        },
        validateCode() {
            LoaderPopup.show();
            axios.put(`/verifications/${this.code}/phone`)
            .then(response => {
                this.code_verified = true;
                this.$router.push('/auth/email');
                LoaderPopup.hide();
            })
            .catch(error => {
                this.error = error.response.data.message;
                LoaderPopup.hide();
            });
        }
    }
}